import { Card, CardButtonActionMode, HeaderGradient, MiniCard, Row } from '@app/components';
import React, { memo } from 'react';
import { theme } from '@app/theme';
import { useDynamicSizes } from '@app/hooks';
import LinearGradient from 'react-native-linear-gradient';
import { StyleSheet } from 'react-native';
import { ITag } from '@app/common';
import { useAppSelector } from '@app/store/hooks';
import { triptychSelectors } from '@app/store';
import { SlantTitle } from '@app/components/typography';
import SvgInfo from '@app/components/icons/SvgInfo';

type TagCardProps = {
  tag?: Partial<ITag>;
  toggle: (mode: CardButtonActionMode) => void;
};

const formatCardData = (partialTag: Partial<ITag>) => {
  return {
    name: partialTag?.name || 'Nouvelle catégorie'
  }
}

export const TagCard = memo(({ toggle, tag }: TagCardProps) => {
  const { subContainerHeight } = useDynamicSizes();

  const partialTag = useAppSelector<Partial<ITag>>(triptychSelectors.selectData);
  const cardData = useAppSelector<Partial<ITag>>(triptychSelectors.selectCardData);

  const { name } = formatCardData(cardData ?? partialTag);

  return (
    <Card>

      <HeaderGradient>
        <LinearGradient
          start={{ x: 0.5, y: 0 }}
          end={{ x: 0.5, y: 1 }}
          locations={[0, 1]}
          colors={['rgba(253, 255, 252, 0)', 'rgba(253, 255, 252, 1)']}
          style={styles.headerGradient}
        />
      </HeaderGradient>

      <Card.TopHeader>
        <Card.TopHeaderLabel>Fiche catégorie</Card.TopHeaderLabel>
      </Card.TopHeader>

      <Card.Container height={subContainerHeight}>
        <Card.Background source={require('@app/assets/img/cardbackground.png')} />

        <Card.Content>
          <Card.Header>
            {/* En-tête */}
            <Row justify="space-between" align="center">
              <Card.HeaderTitles>
                <Card.Title numberOfLines={2}>{name}</Card.Title>
                {tag?._id && <Card.Subtitle>Ref: {tag._id}</Card.Subtitle>}
              </Card.HeaderTitles>

              <Card.ButtonAction onPress={toggle} permissionScope="tags" />
            </Row>
          </Card.Header>
        </Card.Content>

        <MiniCard>
          <MiniCard.Tabs>
            <MiniCard.TabsHolder>
              <MiniCard.Tab Icon={SvgInfo} isActive />
            </MiniCard.TabsHolder>
          </MiniCard.Tabs>
          <MiniCard.Container>
            <MiniCard.Content>
              <SlantTitle label="Aide" color={theme.colors.gold} />

              <Card.HelpScrollContainer>

                <Card.LineBreak height={16} />

                <Card.HelpTitle>Fonctionnement des catégories</Card.HelpTitle>

                <Card.LineBreak height={16} />

                <Card.HelpText>
                  Les catégories vous permettent de classer vos produits.
                </Card.HelpText>

                <Card.HelpText>
                  Pour créer une sous-catégorie, rattachez-la à une catégorie parente.
                </Card.HelpText>

                <Card.HelpText>
                  Utilisez les positions pour organiser l’ordre d’affichage de vos catégories et sous-catégories.
                </Card.HelpText>

                <Card.LineBreak height={360} />

              </Card.HelpScrollContainer>
            </MiniCard.Content>
          </MiniCard.Container>
        </MiniCard>

      </Card.Container>
    </Card>
  );
});


const styles = StyleSheet.create({
  headerGradient: {
    flex: 1,
    height: theme.sizes.listHeaderHeight,
  },
});
